const Theme = {
  card_max_width: 1140,

  logo_image_url: 'borealis.png',

  button_color: '#d2253d',

  text_font: `'Rubik', sans-serif`,
  text_color: 'black',
  title_font: `'Rubik', sans-serif`,
  title_weight: 400,
}

export default Theme
